import { Feature } from "../util/turf";
import { siteGeometryStore } from "../stores/siteGeometry/store";
import { Cluster } from "../types/Cluster";
import { fetchGet } from "./client";

type GetSiteGeometryInput = {
  boundsCenter: [number, number];
  boundsDistance: number;
};

type GetSiteGeometryOutput = {
  sites: {
    type: "FeatureCollection";
    features: Feature[];
  };
  clusters: Cluster[];
};

export const getSiteGeometry = async ({
  boundsCenter,
  boundsDistance,
}: GetSiteGeometryInput): Promise<GetSiteGeometryOutput | undefined> => {
  const params = {
    geojson: true.toString(),
    bounds_center: `${boundsCenter[0]},${boundsCenter[1]}`,
    bounds_distance: boundsDistance.toString(),
  };
  const path = `/sites`;
  try {
    const { abort, result } = fetchGet(path, params);
    siteGeometryStore.activeRequestAbort = abort;
    const responseJson = await (await result).json();
    return responseJson as GetSiteGeometryOutput;
  } catch (_) {
    return undefined;
  } finally {
    siteGeometryStore.activeRequestAbort = undefined;
  }
};
